import React, { useEffect, useMemo, useState } from 'react'
import WebMain from '../front/WebMain'
import { Row, Col, Form, Input, Button, message, Modal, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useKehuzcCodeMutation, useKehuzhuceMutation } from '../store/ReactWebSiteApi'

function FirmRegister() {
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const [countdown, setCountdown] = useState(0)
    const [getCode] = useKehuzcCodeMutation()
    const [submit] = useKehuzhuceMutation()

    const codeValue = Form.useWatch('code', form) || ''
    const submitDisabled = useMemo(() => !/^\d{6}$/.test(String(codeValue).trim()), [codeValue])

    useEffect(() => {
        if (countdown <= 0) return undefined
        const timer = setInterval(() => {
            setCountdown((prev) => (prev <= 1 ? 0 : prev - 1))
        }, 1000)
        return () => clearInterval(timer)
    }, [countdown])

    const getCodeBtn = async () => {
        if (countdown > 0) {
            message.warning('请勿重复点击！')
            return
        }
        const phone = String(form.getFieldValue('phone') || '').trim()
        if (!/^1\d{10}$/.test(phone)) {
            message.warning('请先输入正确的手机号')
            return
        }

        try {
            const res = await getCode({ phone: phone })
            if (res?.data?.Status === 'success') {
                setCountdown(60)
                message.success('验证码已发送')
                return
            }
            message.error(res?.data?.Msg || '验证码发送失败')
        } catch (error) {
            message.error('验证码发送失败，请稍后重试')
        }
    }

    const onFinish = (values) => {
        submit({
            byxkh_name: values.entName,
            byxkh_yh_name: values.userName,
            byxkh_yh_phone: values.phone,
            phone_code: values.code,
        }).then((res) => {
            if (res?.data?.Status === 'success') {
                Modal.success({
                    title: '注册成功',
                    content: '恭喜您，注册成功了！初始密码是123456，点击确认按钮跳转到登录页面！',
                    okText: '确认',
                    onOk: () => navigate('/FirmLogin'),
                })
                return
            }
            message.error(res?.data?.Msg || '注册失败')
        })
    }

    return (
        <WebMain>
            <Row style={{ padding: '60px 0', backgroundColor: '#ddd' }}>
                <Col span={9} />
                <Col span={6} style={{ backgroundColor: '#fff', padding: '40px', borderRadius: '10px' }}>
                    <h1 style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>
                        企业用户注册
                    </h1>
                    <Form
                        layout='horizontal'
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 14 }}
                        initialValues={{
                            entName: '',
                            userName: '',
                            phone: '',
                            code: '',
                        }}
                        onFinish={onFinish}
                        form={form}
                    >
                        <Form.Item label='企业名称' name='entName' required>
                            <Input style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item label='用户名称' name='userName' required>
                            <Input style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item label='手机号码' name='phone' required>
                            <Input style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item label='验证码' name='code' required>
                            <Space>
                                <Input maxLength={6} style={{ width: '100%' }} />
                                <Button type='primary' htmlType='button' onClick={getCodeBtn}>
                                            {countdown > 0 ? `${countdown}s` : '获取验证码'}
                                </Button>
                            </Space>
                        </Form.Item>
                        <Form.Item wrapperCol={{ offset: 6, span: 14 }}>
                            <Button type='primary' htmlType='submit' disabled={submitDisabled}>
                                提交
                            </Button>
                        </Form.Item>
                        <Form.Item wrapperCol={{ offset: 6, span: 14 }}>
                            <a style={{color:'#1890ff'}} onClick={() => {navigate('/FirmLogin')}}>已有账号？请使用手机号登录</a>
                        </Form.Item>
                    </Form>
                    
                </Col>
                <Col span={9} />
            </Row>
        </WebMain>
    )
}

export default FirmRegister